export const locale = {
  lang: 'en',
  data: {
    PANEL_TITLE: 'Reconciliation details',
    TICKET_STATUS: {
      PENDING: 'Unprocessed',
      WAITING_APPROVAL: 'Pending approval',
      REQUEST_MODIFICATION: 'Adjustment needed',
      COMPLETED: 'Processed',
    },
    RECONCILE_STATUS: {
      RECONCILED: 'Reconciled',
      TO_BE_RECONCILE: 'To be reconciled',
      ORDER_NOT_FOUND: 'Order not found',
      TX_NOT_FOUND: 'Transaction not found',
    },
    SUMMARY_INFO: {
      CUSTOMER_INFO: 'Customer Info',
      ORDER_INFO: 'Order Info',
      TRANSACTION_INFO: 'Transaction Info',
      CONTACT: 'Contact',
      SHIPPING_ADDRESS: 'Shipping Address',
      EMAIL_FOR_CHECKOUT: 'Email for checkout',
      TRANSACTION_ID: 'Transaction ID',
      ORDER_ID: 'Order ID',
      ORDER_DATE: 'Order date',
      ITEM: 'Item',
      SKU: 'SKU',
      BUNDLE_NAME: "Bundle",
      GIFT: "Gift",
      REFERENCE_TXN_ID: 'Reference Txn Id/ Order Ref',
      EXTERNAL_REFERENCE_NO: 'External Reference No',
      DATE: 'Date',
      TYPE: 'Type',
      PAYMENT_METHOD: 'Payment method',
      PAYMENT_METHOD_TYPE: {
        PAYPAL: 'PayPal Checkout',
        TWOCHECKOUT: '2Checkout',
        ONEPAY_CREDIT: 'Onepay credit',
        ONEPAY_ATM: 'Onepay ATM',
        ONEPAY_QR: 'Onepay - QR Payment',
        ONEPAY_QR_REFUND: 'Onepay QR Refund',
        ONEPAY_VIETQR: 'Onepay - VietQR',
        ONEPAY_VIETQR_REFUND: 'Onepay VietQR Refund',
        ONEPAY_MP: 'Onepay - Merchant Portal (MP)',
        PAYPAL_HK: 'PayPal Hong Kong',
        STRIPE: 'Stripe'
      },
    },
    RECONCILIATION_RESULTS: {
      TITLE: 'Reconciliation results',
      ORDER_SUMMARY: 'Order',
      TOTAL_PAYMENT: 'Total',
      SHIPPING_COST: 'Shipping cost',
      DISCOUNT: 'Discount',
      TOTAL_PAID: 'Total paid',
      INVOICE_SUMMARY: 'Invoice',
      AMOUNT: 'Amount',
    },
    WORKING_HISTORY: {
      TITLE: 'Working history',
      TIME: 'Time',
      CONTENT: 'Content',
    },
    DUPLICATE_ORDER_CONFIRMATION: {
      CONFIRM_HEADER: 'Archive the duplicated order',
      CONFIRM_MESSAGE:
        'The order will be archived and be moved to <b>Canceled</b> status after confirmation. <br/><br/>This action cannot be reverted.',
      CLOSE_BUTTON_TEXT: 'NO',
      ACCEPT_BUTTON_TEXT: 'ACCEPT',
    },
    CONFIRMATION: {
      TITLE: 'Confirm the reason',
      SELECT_LABEL: 'Choose a reason for mismatching',
      DESCRIPTION: 'Description',
      REFERENCE_TXN_ID: 'Reference Txn ID/Order ID',
      CONFIRM: 'Confirm',
      REQUEST_MODIFICATION: 'Request modification',
      APPROVE: 'Approve',
      REASON: {
        DIFFERENCE_QUANTITY: 'Difference because of quantity',
        DIFFERENCE_COUPON_DISCOUNT: 'Difference because of coupon',
        GIFT_ORDER: 'Gift Order',
        DUPLICATE_ORDER: 'Duplicated order',
        PAY_ANOTHER_METHOD: 'Customer paid by another method',
        NO_ORDER: 'No order created',
        NO_PAYMENT: 'Non commercial payment',
        REFUNDING_ORDER: 'Refunding an order',
        ADDITIONAL_PAYMENT: 'Additional payment',
        OTHERS: 'Others',
      },
      ERROR: {
        REQUIRED: 'Please input reason',
      },
    },
    COMMENT: {
      TITLE: 'Comment',
      PLACEHOLDER: 'Comment',
      NOTE: 'Max 400 characters',
      ICON_EMOJI: 'Insert Emoji',
      ICON_ATTACH: 'Attach file',
      ICON_SEND: 'Send',
    },
    DIALOG: {
      CONFIRM_HEADER: 'Confirmation success!',
      CONFIRM_MESSAGE: 'Successfully confirmed data will be transferred to your Manager',
      CLOSE_BUTTON_TEXT: 'CLOSE',
      APPROVAL_SUCCESS: 'Approval success!',
      APPROVAL_SUCCESS_MSG: 'Ticket <strong>{{ticketId}}</strong> has been approved successfully.',
      REQUEST_SUCCESS: 'Sent the request modification success',
      REQUEST_SUCCESS_MSG: 'Ticket <strong>{{ticketId}}</strong> has been sent to Accountant with status is Adjustment needed.',
    },
    COPPIED: 'Coppied'
  },
};
